<template>
    <v-container>
        <v-layout grid>
            <v-flex md4 xs12>
                <Chart :chartdata="collection" :options="options" type="bar"></Chart>
            </v-flex>
            <v-flex md4 xs12>
                <Chart :chartdata="pie" type="pie"></Chart>
            </v-flex>
            <v-flex md4 xs12>
                <Chart :chartdata="line" type="line-graph"></Chart>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import Chart from '@/components/charts/Charts';
export default {
    data(){
        return{
            collection: {},
            pie: {},
            line: {},
            options: {},
        }
    },
    methods:{
        fillData(){
            this.line = {
                labels: ['A', 'B', 'C'],
                datasets: [
                    {
                        label: 'Data One',
                        borderColor: '#f87979',
                        backgroundColor: 'transparent',
                        data: [10,30,15]
                    }, 
                    {
                        label: 'Data Two',
                        borderColor: 'green',
                        backgroundColor: 'transparent',
                        data: [20,50,40]
                    }, 
                    {
                        label: 'Data Three',
                        borderColor: 'Red',
                        backgroundColor: 'transparent',
                        data: [15,60,35]
                    }, 
                ],
            }
            this.pie = {
                datasets:[
                    {
                        data:[10, 20, 30],
                        backgroundColor: ['green', 'red', 'yellow']

                    },
                ],
                labels:['A', 'B', 'C']
            }
            this.collection = {
                labels: ['A', 'B', 'C'],
                datasets: [
                    {
                        label: 'Data One',
                        backgroundColor: '#f87979',
                        data: [10,,]
                    }, 
                    {
                        label: 'Data Two',
                        backgroundColor: '#fff',
                        data: [,20,]
                    },
                    {
                        label: 'Data Three',
                        backgroundColor: 'green',
                        data: [,,30]
                    }
                ],
            }
            this.options ={
                scales:{
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true
                            }
                        }
                    ],
                    
                }
            }
        }
    },
    components:{
        Chart
    },
    beforeMount(){
        this.fillData()
    }
}
</script>

